<template>
  <div>
    <el-dialog :title="title" :visible.sync="show" width="900px" @close="close">
      <!-- 所属用户 -->
      <el-form
        v-if="show"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="125px"
      >
        <el-form-item label="名称" prop="title">
          <el-input
            v-model="form.title"
            maxlength="30"
            show-word-limit
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="线路选择" prop="kor_type">
          <el-select v-model="form.kor_type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效期类型" prop="term_of_validity">
          <el-radio-group v-model="form.term_of_validity">
            <el-radio :label="1">固定时间段</el-radio>
            <el-radio :label="2">领取后多少天有效</el-radio>
            <el-radio :label="3">永久有效</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="适用范围" prop="goods_type">
          <el-radio-group v-model="form.goods_type">
            <el-radio :label="1">所有商品可用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠劵面值" prop="money">
          <el-input
            v-model="form.money"
            maxlength="8"
            show-word-limit
            autocomplete="off"
            @input="form.money = $geShi(form.money)"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="form.term_of_validity == 1"
          label="生效时间"
          prop="times"
        >
          <el-date-picker
            v-model="form.times"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="time_change"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          v-if="form.term_of_validity == 2"
          label="生效时间"
          prop="days"
        >
          <el-input
            v-model="form.days"
            maxlength="8"
            placeholder="领取后**天后过期"
            show-word-limit
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠劵门槛" prop="at_least">
          <el-input
            v-model="form.at_least"
            maxlength="8"
            placeholder="优惠劵门槛"
            show-word-limit
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="单用户可领取数" prop="count">
          <el-input
            v-model="form.count"
            maxlength="8"
            show-word-limit
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="remark">
          <el-input
            v-model="form.remark"
            maxlength="50"
            show-word-limit
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            v-model="form.sort"
            maxlength="5"
            show-word-limit
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label="">

        </el-form-item>
        <el-form-item label="邀请码">
          <div style="display: flex; align-items: center;">

            <div class="code_box" v-for="(item,index) in form.code" :key="index">
              {{item}}
              <i class="el-icon-error" style="cursor: pointer; color:red;" @click="del_code(index)"></i>
            </div>
            <el-input style="width:250px;" v-model="code" maxlength="8"  show-word-limit  autocomplete="off" >
              <span slot="append" @click="add_code(code)" style="cursor: pointer;"> 添加邀请码 </span>
            </el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    coupon_add,
    coupon_list,
    coupon_detail,
    coupon_update,
    coupon_del,
  } from '@/api/coupon'

  export default {
    name: 'CouponEdit',
    filters: {},
    data() {
      return {
        code:null,
        is_add: true,
        show: false,
        title: '添加优惠劵',
        form: {
          title: null, //名称
          money: null, //面值
          term_of_validity: 1, //有效期类型 1固定时间段 2领取后多少天有效 3永久有效
          start_time: null, //开始时间
          end_time: null, //结束时间
          days: null, //当有效期类型为2时设定值天数
          at_least: null, //最小金额
          count: null, //单用户可领取数
          remark: null, //描述
          sort: null, //排序
          kor_type: null, //0韩到中 3韩到日 4韩到马来 5中到马来
          code: [], //邀请码
          times: null,
          goods_type: 1,
        },
        options: [
          { label: '韩到中', value: 0 },
          { label: '韩到日', value: 3 },
          { label: '韩到马来', value: 4 },
          { label: '中到马来', value: 5 },
        ],
        rules: {
          times: [
            {
              validator: (rule, value, callback) => {
                if (value) {
                  callback()
                } else {
                  callback(new Error('请选择生效时间'))
                }
              },
              required: true,
              trigger: ['blur', 'change'],
            },
          ],
          type: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请选择仓库所在区',
            },
          ],
          title: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请输入优惠劵名称',
            },
          ],
          goods_type: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请设置优惠劵适用范围',
            },
          ],
          money: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请输入优惠劵面额',
            },
          ],
          term_of_validity: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请设置优惠劵有效期',
            },
          ],
          start_time: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请设置有效时间段',
            },
          ],
          days: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请设置有效期',
            },
          ],
          at_least: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请设置最小金额',
            },
          ],
          count: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请设置单用户可领取数',
            },
          ],
          remark: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请输入优惠劵描述',
            },
          ],
          kor_type: [
            {
              required: true,
              trigger: ['blur', 'change'],
              message: '请设置优惠劵线路',
            },
          ],
        },
      }
    },
    mounted() {},
    methods: {
      del_code(index){
        this.form.code.splice(index , 1)
      },
      add_code(){
        if(this.code){
          this.form.code.push(this.code)
          this.code = null

        }else{
          this.$message({
            type:"warning",
            message:'邀请码不能为空!'
          })
        }
      },
      time_change(e) {
        // 时间段改变
        if (e) {
          this.form.start_time = e[0]
          this.form.end_time = e[1]
        } else {
          this.form.start_time = null
          this.form.end_time = null
        }
      },
      show_edit(e) {
        // 添加编辑优惠劵
        if (e.id) {
          this.is_add = false
          var data = {
            id: e.id,
          }
          coupon_detail(data).then((res) => {
            this.show = true
            if(res.data.code){
              res.data.code = res.data.code.split(',')
            }else{
              res.data.code = []
            }
            this.form = res.data
            if (res.data.start_time) {
              this.form.times = [res.data.start_time, res.data.end_time]
            }
          })
        } else {
          this.is_add = true
          this.show = true
        }
      },
      close() {
        // 关闭优惠劵对话框
        this.show = false
        this.$emit('saves', 'err')
      },
      save() {
        // 添加/修改优惠劵保存
        if(this.code){
          this.$message({
            type:'warning',
            message:'有未保存的邀请码! 请添加后重试'
          })
          return
        }
        var form = JSON.parse(JSON.stringify(this.form))
        form.code = form.code.join(',')
        var data = {
          ...form,
        }
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.is_add) {
              coupon_add(data).then((res) => {
                this.$message({
                  type: 'success',
                  message: '添加成功',
                })
                this.close()
                this.$emit('saves', 'success')
              })
            } else {
              coupon_update(data).then((res) => {
                this.$message({
                  type: 'success',
                  message: '修改成功',
                })
                this.close()
                this.$emit('saves', 'success')
              })
            }
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
    },
  }
</script>
<style>
  .code_box{
    padding:0px 8px;
    border: 1px solid #dcdfe6;
    margin-right:4px;

  }
</style>
